import type { ShopMessageKey } from '../../../i18n'
import { writeBooleanPreference, type BillingFormState } from './preferencesShared'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

type SaveBillingDataInput = {
  billingFormState: BillingFormState
  normalizedTaxCode: string
  taxCodeInvalid: boolean
  billingEmailInvalid: boolean
  billingPreferenceStorageKey: string
  useForNextOrders: boolean
  setTouchedTaxCode: (value: boolean) => void
  setTouchedBillingEmail: (value: boolean) => void
  setBillingError: (value: string) => void
  setSaveState: (value: 'idle' | 'saved' | 'error') => void
  setSaving: (value: boolean) => void
  onUpdateProfile: (payload: {
    firstName?: string
    lastName?: string
    taxCode?: string
    phone?: string
    email?: string
  }) => Promise<boolean>
  t: TranslateFn
}

export const saveBillingDataAction = async ({
  billingFormState,
  normalizedTaxCode,
  taxCodeInvalid,
  billingEmailInvalid,
  billingPreferenceStorageKey,
  useForNextOrders,
  setTouchedTaxCode,
  setTouchedBillingEmail,
  setBillingError,
  setSaveState,
  setSaving,
  onUpdateProfile,
  t,
}: SaveBillingDataInput) => {
  const firstName = billingFormState.firstName.trim()
  const lastName = billingFormState.lastName.trim()
  const taxCode = normalizedTaxCode
  const phone = billingFormState.phone.trim()
  const billingEmail = billingFormState.billingEmail.trim()

  if (!firstName || !lastName || !taxCode || taxCodeInvalid || billingEmailInvalid) {
    setTouchedTaxCode(true)
    setTouchedBillingEmail(true)
    setBillingError(t('customer.preferences.billing.requiredFieldsError'))
    setSaveState('idle')
    return
  }

  setSaving(true)
  setBillingError('')

  const payload: {
    firstName: string
    lastName: string
    taxCode: string
    phone?: string
    email?: string
  } = {
    firstName,
    lastName,
    taxCode,
  }

  if (phone) payload.phone = phone
  if (billingEmail) payload.email = billingEmail

  const saved = await onUpdateProfile(payload)
  if (saved) {
    writeBooleanPreference(billingPreferenceStorageKey, useForNextOrders)
    setSaveState('saved')
  } else {
    setSaveState('error')
  }

  setSaving(false)
}
